// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__bv16B","brand":"Footer_brand__c6cY-","igLogo":"Footer_igLogo__REfcm"};